import { useTranslations } from "next-intl";

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

const tabs = [
  ["overview", false],
  ["localization", true],
  ["apiBoundary", true],
  ["diagnostics", true],
  ["applicationShell", true],
] as const;

export function Navbar() {
  const t = useTranslations("layout30.mobileSections");

  return (
    <div className="pb-5">
      <Tabs
        defaultValue="overview"
        className="inline-grid text-sm text-muted-foreground lg:[&_[data-slot=tabs-trigger]]:flex-1"
      >
        <TabsList
          size="xs"
          className="inline-flex shrink-0 overflow-auto border border-border/80 bg-muted/80 [&_[data-slot=tabs-trigger]]:font-normal [&_[data-slot=tabs-trigger]]:text-foreground [&_[data-slot=tabs-trigger][data-state=active]]:shadow-lg"
        >
          {tabs.map(([key, disabled]) => (
            <TabsTrigger key={key} value={key} disabled={disabled}>
              {t(key)}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
}
